import { render, staticRenderFns } from "./DatabaseForm.vue?vue&type=template&id=d241cf72&scoped=true&"
import script from "./DatabaseForm.vue?vue&type=script&lang=js&"
export * from "./DatabaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d241cf72",
  null
  
)

export default component.exports